/**
 * better-auth web client.
 *
 * The web counterpart to the mobile app's client (tripbears/lib/authClient.ts).
 * Two deliberate differences:
 *
 *  - No `expoClient` plugin. That plugin exists to persist cookies in
 *    SecureStore and drive the `tripbears://` deep-link OAuth round trip; a
 *    browser does both natively.
 *  - No bearer token extraction. The session travels as an httpOnly cookie the
 *    page cannot read, which is the point — it is not exposed to page scripts.
 *
 * `emailOTPClient` is shared with mobile because the backend routes *all* email
 * verification and password reset through 6-digit codes
 * (`overrideDefaultEmailVerification: true` in the API's src/lib/auth.ts). There
 * are no magic links to land on, which suits the invitation flow: a link would
 * navigate the user away mid-accept and lose the pending token.
 */
import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

import { API_BASE_URL } from "@/lib/config";
import { assertWebAuthRequestAllowed } from "@/features/auth/policy";

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  basePath: "/auth",
  fetchOptions: {
    // The session cookie is set on a parent domain shared with the API
    // (AUTH_COOKIE_DOMAIN), so every auth call must be credentialed or the
    // browser will neither send nor store it.
    credentials: "include",
    onRequest: ({ url }) => assertWebAuthRequestAllowed(url),
  },
  plugins: [emailOTPClient()],
});

export const { useSession, signIn, signUp, signOut, emailOtp } = authClient;
